// extracted by mini-css-extract-plugin
module.exports = {"title":"ticketerror_title__3Rb8B","text":"ticketerror_text__16VX7"};